import script from "./NavigationDrawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavigationDrawer.vue?vue&type=script&lang=ts&setup=true"

import "./NavigationDrawer.vue?vue&type=style&index=0&id=5c55c2e0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c55c2e0"]])

export default __exports__